import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgConsultHistoryGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M34.51 9.68H31.7v-.93c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.93H17.79v-.93a.749.749 0 1 0-1.5 0v.93h-2.8C10.46 9.68 8 12.15 8 15.17v19.34C8 37.54 10.46 40 13.49 40h21.03c3.03 0 5.49-2.46 5.49-5.49V15.17c-.01-3.02-2.47-5.49-5.5-5.49Zm-21.02 1.5h2.81v.76c0 .41.34.75.75.75s.75-.34.75-.75v-.76h12.41v.7c0 .41.34.75.75.75s.75-.34.75-.75v-.7h2.81c2.2 0 3.99 1.79 3.99 3.99v5.86h-29v-5.86a3.98 3.98 0 0 1 3.98-3.99ZM34.51 38.5H13.49c-2.2 0-3.99-1.79-3.99-3.99V22.53h29v11.98c0 2.2-1.79 3.99-3.99 3.99Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M17.04 18.25c.78 0 1.42-.64 1.42-1.42a1.419 1.419 0 1 0-1.42 1.42ZM30.96 18.25c.78 0 1.42-.64 1.42-1.42a1.419 1.419 0 1 0-2.84 0c-.01.79.63 1.42 1.42 1.42ZM31.63 29.76H19.08c.86-.85 1.55-2.07 1.55-3.71 0-.41-.34-.75-.75-.75s-.75.34-.75.75c0 2.88-2.85 3.74-2.97 3.77a.747.747 0 0 0-.04 1.43c.12.04 3.04 1.06 3.04 3.72 0 .41.34.75.75.75s.75-.34.75-.75c0-1.7-.8-2.9-1.69-3.71h12.64c.41 0 .75-.34.75-.75s-.32-.75-.73-.75Z",
    fill: "currentColor"
  }));
}

export { SvgConsultHistoryGlyphSecondary as default };
